import { useQuery } from '@tanstack/react-query';

import { apiRequest } from '../api';
import { queryKeys } from '../queryKeys';
import type { User } from '../types';

export function useCurrentUser() {
  return useQuery({
    queryKey: queryKeys.me,
    queryFn: () => apiRequest<{ user: User }>('/api/me').then((r) => r.user),
    staleTime: 5 * 60_000,
    retry: false,
  });
}
